
import { useCallback, useSyncExternalStore } from "react";

export const BREAKPOINTS = {
  tablet: 840,
  laptop: 1024,
  desktop: 1440,
  landscapePhoneHeight: 500,
} as const;

export const MEDIA = {
  phone: `(max-width: ${BREAKPOINTS.tablet - 0.02}px)`,
  tabletUp: `(min-width: ${BREAKPOINTS.tablet}px)`,
  tablet: `(min-width: ${BREAKPOINTS.tablet}px) and (max-width: ${BREAKPOINTS.laptop - 0.02}px)`,
  laptopUp: `(min-width: ${BREAKPOINTS.laptop}px)`,
  desktopUp: `(min-width: ${BREAKPOINTS.desktop}px)`,
  landscapePhone: `(max-width: ${BREAKPOINTS.tablet - 0.02}px) and (max-height: ${BREAKPOINTS.landscapePhoneHeight - 0.02}px)`,
  coarsePointer: "(pointer: coarse)",
  reducedMotion: "(prefers-reduced-motion: reduce)",
} as const;

const serverSnapshot = () => false;

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );
  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);
  return useSyncExternalStore(subscribe, getSnapshot, serverSnapshot);
}
